import { SimplifiedOnboardingWizard } from '@/components/onboarding';

/**
 * FR-7: Simplified Onboarding
 * Single-step onboarding with company name + primary color only
 * Smart defaults applied automatically
 */
export default function Onboarding() {
  return <SimplifiedOnboardingWizard />;
}
